import { NbJSThemeOptions } from '@nebular/theme';

export const REVUTO_THEME = {
  name: 'revuto',
  base: 'default',
} as NbJSThemeOptions;
